let orderFormPreload
let starsOrderFormPreload
let premiumOrderFormPreload
let topUpModalPreload
let orderSuccessPreload
let lottiePlayerPreload
let rentCatalogPreload
let rentCollectionGiftsPreload
let rentDetailPreload
let rentPayPreload
let rentHubPreload
let myRentalsPreload
let usernameCatalogPreload
let usernameDetailPreload
let usernameCardPreload
let numberCatalogPreload
let numberDetailPreload
let numberCardPreload
let adminGatePreload
let iconsPreloaded = false

const PAYMENT_ICON_URLS = [
  '/images/icons/payment/sbp.svg',
  '/images/icons/payment/cryptobot.svg',
  '/images/icons/payment/crypto.svg',
  '/icons/wallet.svg',
]

function preloadPaymentIcons() {
  if (iconsPreloaded) return
  iconsPreloaded = true
  for (const url of PAYMENT_ICON_URLS) {
    const img = new Image()
    img.src = url
  }
}

export function preloadOrderForm() {
  if (!orderFormPreload) {
    orderFormPreload = import('../components/OrderForm')
  }
  return orderFormPreload
}

export function preloadStarsOrderForm() {
  if (!starsOrderFormPreload) {
    starsOrderFormPreload = import('../components/StarsOrderForm')
  }
  return starsOrderFormPreload
}

export function preloadPremiumOrderForm() {
  if (!premiumOrderFormPreload) {
    premiumOrderFormPreload = import('../components/PremiumOrderForm')
  }
  return premiumOrderFormPreload
}

export function preloadLottiePlayer() {
  if (!lottiePlayerPreload) {
    lottiePlayerPreload = import('../components/LottiePlayer')
  }
  return lottiePlayerPreload
}

export function preloadStatusAnimations() {
  void fetch('/images/lottie/json/success.json', { cache: 'force-cache' }).catch(() => {})
  void fetch('/images/status/payment-waiting.json', { cache: 'force-cache' }).catch(() => {})
}

export function preloadTopUpModal() {
  if (!topUpModalPreload) {
    topUpModalPreload = import('../components/TopUpModal')
  }
  preloadPaymentIcons()
  preloadStatusAnimations()
  return topUpModalPreload
}

export function preloadOrderSuccess() {
  if (!orderSuccessPreload) {
    orderSuccessPreload = import('../components/OrderSuccess')
  }
  preloadStatusAnimations()
  return orderSuccessPreload
}

export function preloadRentCatalog() {
  if (!rentCatalogPreload) {
    rentCatalogPreload = import('../components/RentCatalogScreen')
  }
  return rentCatalogPreload
}

export function preloadRentCollectionGifts() {
  if (!rentCollectionGiftsPreload) {
    rentCollectionGiftsPreload = import('../components/RentCollectionGiftsScreen')
  }
  return rentCollectionGiftsPreload
}

export function preloadRentDetail() {
  if (!rentDetailPreload) {
    rentDetailPreload = import('../components/RentDetailScreen')
  }
  return rentDetailPreload
}

export function preloadRentPay() {
  if (!rentPayPreload) {
    rentPayPreload = import('../components/RentPayScreen')
  }
  preloadStatusAnimations()
  return rentPayPreload
}

export function preloadRentHub() {
  if (!rentHubPreload) {
    rentHubPreload = import('../components/RentHubScreen')
  }
  return rentHubPreload
}

export function preloadMyRentals() {
  if (!myRentalsPreload) {
    myRentalsPreload = import('../components/MyRentalsScreen')
  }
  return myRentalsPreload
}

// ── Аренда юзернеймов (Этап 2) ──
export function preloadUsernameCatalog() {
  if (!usernameCatalogPreload) {
    usernameCatalogPreload = import('../components/UsernameCatalogScreen')
  }
  return usernameCatalogPreload
}

export function preloadUsernameDetail() {
  if (!usernameDetailPreload) {
    usernameDetailPreload = import('../components/UsernameDetailScreen')
  }
  return usernameDetailPreload
}

// UsernameCard грузится вместе с каталогом, но прогреем явно для первой отрисовки.
export function preloadUsernameCard() {
  if (!usernameCardPreload) {
    usernameCardPreload = import('../components/UsernameCard')
  }
  return usernameCardPreload
}

// ── Аренда номеров (Этап 3) ──
export function preloadNumberCatalog() {
  if (!numberCatalogPreload) {
    numberCatalogPreload = import('../components/NumberCatalogScreen')
  }
  return numberCatalogPreload
}

export function preloadNumberDetail() {
  if (!numberDetailPreload) {
    numberDetailPreload = import('../components/NumberDetailScreen')
  }
  return numberDetailPreload
}

// NumberCard грузится вместе с каталогом, но прогреем явно для первой отрисовки.
export function preloadNumberCard() {
  if (!numberCardPreload) {
    numberCardPreload = import('../components/NumberCard')
  }
  return numberCardPreload
}

// ── Админка (Этап 1) ── чанк тянется ТОЛЬКО при тапе на шестерёнку:
// обычным юзерам admin-код в бандл не попадает.
export function preloadAdminGate() {
  if (!adminGatePreload) {
    adminGatePreload = import('../components/admin/AdminGate')
  }
  return adminGatePreload
}
